export { default as Dashboard } from './Dashboard';
export {default as DLogin} from './Login';
export {default as Navbar} from './Navbar';
export {default as Footer} from './Footer';